import axiosInst from "api/config/axiosConfig";
import {
  AddMultipleResponseTypes,
  AddMultipleReviewValues,
  AddMultipleUploadedValues,
  MultipleDeviceReviewTypes,
  MultipleDeviceUploadTypes,
} from "./add-multiple-devices.depot";

export enum AddMultipleStatus {
  Claimed = " Rejected, SerialNumber is already claimed",
  InvalidData = "Rejected, Invalid device data",
  Valid = "Valid",
  Added = "Device added",
}

export enum AddMultipleRequests {
  Add = "Add",
  Review = "Review",
}

export enum AddMultipleCsvLabels {
  SN = "SN",
  MAC = "MAC",
}

export async function reviewMultipleDevices(data: MultipleDeviceReviewTypes) {
  const response = await axiosInst.post("/beta/devicesMultiple", data);
  AddMultipleReviewValues.setData([...AddMultipleReviewValues.data, response.data]);
}

export async function uploadDeviceData(data: MultipleDeviceUploadTypes) {
  const response = await axiosInst.post("/beta/devicesMultiple", data);
  AddMultipleUploadedValues.setData([...AddMultipleUploadedValues.data, response.data]);
}
